/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * اسم المتجر = ClientName
 * اسم العميل = CompanyName
 * اسم المستخدم = TenantName / EngTenantName
 * وصف الخدمات = BusinessName
 */

const pickName = (...vals) => {
  for (const v of vals) {
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return "";
};

const safeParse = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}") || {};
  } catch {
    return {};
  }
};

export const getStoreNameFromTenant = (t = {}) =>
  pickName(t.ClientName, t.clientName);

export function getStoreDisplayName(isArabic = true) {
  const tenantDetails = safeParse("tenantDetails");
  const storeData = safeParse("storeData");
  const tenant = safeParse("tenant");

  const name = pickName(
    localStorage.getItem("companyStoreName"),
    getStoreNameFromTenant(tenantDetails),
    getStoreNameFromTenant(storeData),
    getStoreNameFromTenant(tenant)
  );

  return name || (isArabic ? "متجري" : "My Store");
}
